import React from 'react';

const PrivacyPolicyPage = () => (
  <div style={{ maxWidth: '880px', margin: '40px auto', padding: '24px 32px', fontFamily: 'system-ui, -apple-system, sans-serif', color: '#2C2D33', lineHeight: 1.6 }}>
    <h1 style={{ color: '#002FA7', fontSize: '2.2rem', marginBottom: '8px' }}>BATI-BOYS — Politique de confidentialite</h1>
    <p style={{ color: '#5E5F66', fontSize: '0.9rem', marginBottom: '32px' }}>Derniere mise a jour : 19 avril 2026</p>

    <Section title="1. Editeur de l'application">
      <p>L'application <strong>BATI-BOYS</strong> est editee par la societe <strong>BATI-BOYS SARL</strong> au capital de 1 000 €.</p>
      <ul>
        <li><strong>RCS</strong> : Lille Metropole 981 722 721</li>
        <li><strong>SIRET</strong> : 981 722 721 00017</li>
        <li><strong>Siege social</strong> : 229 rue Solferino, 59000 Lille, France</li>
        <li><strong>Representant legal / Responsable de traitement</strong> : Monsieur DJEGHAM Hicham, Gerant</li>
        <li><strong>Contact / Delegue a la protection des donnees</strong> : <a href="mailto:hicham@bati-boys.fr">hicham@bati-boys.fr</a></li>
        <li><strong>Hebergeur</strong> : <em>a completer</em></li>
      </ul>
    </Section>

    <Section title="2. Donnees collectees">
      <p>Dans le cadre de la gestion de chantiers, de pointage et de facturation, BATI-BOYS collecte les donnees suivantes :</p>
      <ul>
        <li><strong>Donnees d'identification</strong> : nom, prenom, email, fonction, photo de profil, numero de securite sociale (salaries uniquement)</li>
        <li><strong>Donnees professionnelles</strong> : heures travaillees, chantiers affectes, materiel remis, notes de frais</li>
        <li><strong>Donnees de connexion</strong> : adresse IP, date et heure de connexion, type de navigateur</li>
        <li><strong>Donnees de geolocalisation</strong> (optionnel, uniquement au moment du pointage) : coordonnees GPS pour valider la presence sur chantier</li>
        <li><strong>Documents</strong> : contrats, feuilles de paie, fiches chantier, factures</li>
      </ul>
    </Section>

    <Section title="3. Finalites du traitement">
      <ul>
        <li>Gestion des heures de travail et production des bulletins de paie</li>
        <li>Suivi des chantiers, devis, factures et operations comptables</li>
        <li>Gestion des ressources : materiel, vehicules, stocks</li>
        <li>Securite de l'acces a l'application et prevention des fraudes</li>
        <li>Respect des obligations legales (URSSAF, droit du travail, fiscalite)</li>
      </ul>
    </Section>

    <Section title="4. Base legale">
      <p>Les traitements reposent sur :</p>
      <ul>
        <li>L'<strong>execution du contrat de travail</strong> (article 6-1-b RGPD) pour les salaries</li>
        <li>L'<strong>interet legitime</strong> de l'entreprise (article 6-1-f RGPD) pour la gestion operationnelle</li>
        <li>L'<strong>obligation legale</strong> (article 6-1-c RGPD) pour les obligations sociales et fiscales</li>
        <li>Le <strong>consentement</strong> pour la geolocalisation au pointage (desactivable a tout moment)</li>
      </ul>
    </Section>

    <Section title="5. Destinataires des donnees">
      <p>Vos donnees sont accessibles uniquement :</p>
      <ul>
        <li>Aux administrateurs autorises de BATI-BOYS</li>
        <li>Aux salaries concernes pour leurs propres donnees</li>
        <li>Aux partenaires techniques suivants : <strong>MongoDB</strong> (hebergement base de donnees), <strong>Resend</strong> (envoi d'emails), <strong>Google Gemini</strong> (analyse OCR de documents uniquement quand vous telechargez un PDF)</li>
        <li>Aux organismes legaux en cas d'obligation (URSSAF, administration fiscale, autorites judiciaires)</li>
      </ul>
      <p>Aucune donnee n'est revendue a des fins commerciales.</p>
    </Section>

    <Section title="6. Duree de conservation">
      <ul>
        <li>Donnees de pointage et paie : <strong>5 ans</strong> apres la fin du contrat de travail</li>
        <li>Factures et devis : <strong>10 ans</strong> (obligation comptable)</li>
        <li>Donnees de connexion : <strong>12 mois</strong></li>
        <li>Donnees de geolocalisation : <strong>3 mois</strong></li>
        <li>Compte utilisateur supprime : donnees anonymisees sous 30 jours</li>
      </ul>
    </Section>

    <Section title="7. Vos droits">
      <p>Conformement au RGPD, vous disposez des droits suivants sur vos donnees :</p>
      <ul>
        <li>Droit d'acces, de rectification et d'effacement</li>
        <li>Droit a la portabilite de vos donnees</li>
        <li>Droit de limitation et d'opposition au traitement</li>
        <li>Droit de retirer votre consentement a tout moment</li>
        <li>Droit d'introduire une reclamation aupres de la CNIL (<a href="https://www.cnil.fr">www.cnil.fr</a>)</li>
      </ul>
      <p>Pour exercer ces droits, contactez <a href="mailto:hicham@bati-boys.fr">hicham@bati-boys.fr</a>. Une reponse vous sera apportee sous 30 jours maximum.</p>
    </Section>

    <Section title="8. Securite">
      <p>BATI-BOYS met en oeuvre les mesures techniques et organisationnelles suivantes :</p>
      <ul>
        <li>Chiffrement HTTPS/TLS de toutes les communications</li>
        <li>Mots de passe hashes avec bcrypt</li>
        <li>Authentification par token JWT signe, expiration 30 jours</li>
        <li>Alertes de securite en cas de connexion depuis une nouvelle adresse IP</li>
        <li>Sauvegardes quotidiennes de la base de donnees</li>
        <li>Acces strictement limite par role (admin / salarie)</li>
      </ul>
    </Section>

    <Section title="9. Cookies et stockage local">
      <p>L'application utilise le stockage local du navigateur (<em>localStorage</em>) uniquement pour conserver votre token d'authentification et vos preferences d'affichage. Aucun cookie publicitaire ou de suivi tiers n'est depose.</p>
    </Section>

    <Section title="10. Notifications push">
      <p>Si vous activez les notifications push, l'application utilise les services Web Push (VAPID) ou APN/FCM (applications mobiles). Vous pouvez les desactiver a tout moment dans les parametres de votre appareil.</p>
    </Section>

    <Section title="11. Modification de la politique">
      <p>Cette politique peut etre mise a jour. Toute modification substantielle sera notifiee aux utilisateurs via l'application au moins 15 jours avant son entree en vigueur.</p>
    </Section>

    <Section title="12. Contact">
      <p>Pour toute question relative a cette politique ou a vos donnees personnelles :</p>
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        <li>📧 <a href="mailto:hicham@bati-boys.fr">hicham@bati-boys.fr</a></li>
        <li>📍 BATI-BOYS SARL, 229 rue Solferino, 59000 Lille</li>
        <li>👤 Responsable : Monsieur DJEGHAM Hicham, Gerant</li>
      </ul>
    </Section>

    <div style={{ marginTop: '40px', padding: '16px 20px', backgroundColor: '#F4F5F7', borderRadius: '6px', fontSize: '0.85rem', color: '#5E5F66', textAlign: 'center' }}>
      <strong>BATI-BOYS</strong> &middot; Gestion de chantiers et pointage BTP
    </div>
  </div>
);

const Section = ({ title, children }) => (
  <section style={{ marginBottom: '28px' }}>
    <h2 style={{ color: '#002FA7', fontSize: '1.3rem', borderBottom: '2px solid #E2E2E6', paddingBottom: '6px', marginBottom: '12px' }}>{title}</h2>
    {children}
  </section>
);

export default PrivacyPolicyPage;
